const { $ } = window

export default {
	init() {
		let tabs = ['dashboard', 'resources', 'training']
		tabs.map((item) => {
			$('a[href="#' + item + '"]').on('click', (e) => {
				e.preventDefault()
				document.querySelector('.active').classList.remove('active')
				e.currentTarget.classList.add('active')
				tabs.map((tab) =>
					document.getElementById(tab).classList.remove('container-show')
				) //.style.display = 'none')
				document.getElementById(item).classList.add('container-show') //style.display = "block"
			})
		})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
